const API_URL = process.env.REACT_APP_BACKEND_URL;

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('cadence_token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Contact/Inquiry API
export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to submit contact form');
    }

    return await response.json();
  } catch (error) {
    console.error('Contact form error:', error);
    throw error;
  }
};

// Consultation API
export const createConsultation = async (consultationData) => {
  try {
    const response = await fetch(`${API_URL}/api/consultations`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(consultationData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to create consultation');
    }

    return await response.json();
  } catch (error) {
    console.error('Create consultation error:', error);
    throw error;
  }
};

export const getConsultations = async () => {
  try {
    const response = await fetch(`${API_URL}/api/consultations`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch consultations');
    }

    return await response.json();
  } catch (error) {
    console.error('Get consultations error:', error);
    throw error;
  }
};

// Membership API
export const createMembership = async (membershipData) => {
  try {
    const response = await fetch(`${API_URL}/api/memberships`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(membershipData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to create membership');
    }

    return await response.json();
  } catch (error) {
    console.error('Create membership error:', error);
    throw error;
  }
};

export const getCurrentMembership = async () => {
  try {
    const response = await fetch(`${API_URL}/api/memberships/current`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch membership');
    }

    return await response.json();
  } catch (error) {
    console.error('Get membership error:', error);
    throw error;
  }
};

export const cancelMembership = async () => {
  try {
    const response = await fetch(`${API_URL}/api/memberships/cancel`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to cancel membership');
    }

    return await response.json();
  } catch (error) {
    console.error('Cancel membership error:', error);
    throw error;
  }
};

// Affiliate API
export const applyForAffiliate = async (affiliateData) => {
  try {
    const response = await fetch(`${API_URL}/api/affiliates/apply`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(affiliateData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to apply for affiliate program');
    }

    return await response.json();
  } catch (error) {
    console.error('Affiliate apply error:', error);
    throw error;
  }
};

export const getAffiliateStats = async (email) => {
  try {
    const response = await fetch(`${API_URL}/api/affiliates/stats?email=${encodeURIComponent(email)}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch affiliate stats');
    }

    return await response.json();
  } catch (error) {
    console.error('Get affiliate stats error:', error);
    throw error;
  }
};

// Health Check
export const healthCheck = async () => {
  try {
    const response = await fetch(`${API_URL}/api/health`);
    return await response.json();
  } catch (error) {
    console.error('Health check error:', error);
    throw error;
  }
};

export default {
  submitContactForm,
  createConsultation,
  getConsultations,
  createMembership,
  getCurrentMembership,
  cancelMembership,
  applyForAffiliate,
  getAffiliateStats,
  healthCheck,
};
